import { render, staticRenderFns } from "./TrainingSummariesWithImages.vue?vue&type=template&id=024f80ec&"
import script from "./TrainingSummariesWithImages.vue?vue&type=script&lang=js&"
export * from "./TrainingSummariesWithImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports